import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {TheCrypt} from "../TheCrypt";
import {TheCryptGameAssets} from "../TheCryptGameAssets";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {BitmapText} from "pixi.js";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {IWinRatioConfig, TheCryptWinConfig} from "../configs/TheCryptWinConfig";
import Spine = PIXI.spine.Spine;

export class TheCryptTotalWinView extends PIXI.Container implements StageLayer {
    private _countUp: BasicBitmapCountUp;

    constructor() {
        super();
        this.name = "TotalWin";
        this.init();
    }

    public show(winRatioConfig: IWinRatioConfig): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            totalWinWays: number = TheCrypt.model.gameData.waysWonTotalRound,
            winType: string = winRatioConfig.type;
        let toggleType: string = TheCryptHelper.getToggleType();
        const waysNumber = new BitmapText(totalWinWays.toString(), {
            fontName: TheCryptGameAssets.BITMAP_FONT_WIN_WAYS,
            fontSize: 40,
            tint: 0xffffff
        });
        waysNumber.anchor = new PIXI.Point(0, 1);

        const effect: Spine = new PIXI.spine.Spine(TheCrypt.assetLoader.getSpineAsset("total_win"));
        effect.position.set(360, 360);
        effect.name = "totalWin" + toggleType;
        effect.visible = false;

        const waysText = new PIXI.Sprite(TheCrypt.assetLoader.getTextures(`Way${totalWinWays > 1 ? "s" : ""}`)[0]);
        waysText.anchor = new PIXI.Point(0, 0.6);
        waysNumber.letterSpacing = -12;
        const startPos: number = 360 - (waysNumber.width + waysText.width) * 0.5;
        waysNumber.position.set(startPos, 484);
        waysText.position.set(startPos + waysNumber.width, 472);
        this.addChild(effect, waysNumber, waysText, this._countUp);
        tl.add(() => {
            this._countUp.stopAt(0);
            this._countUp.scale.set(0.5, 0.5);
            this._countUp.alpha = 1;
            this.alpha = 0;
            this.visible = true;
        });
        tl.add([
            TweenLite.to(this, 0.1, {alpha: 1}),
            TweenLite.to(this._countUp.scale, 0.1, {x: 1, y: 1, ease: "sine.in"}),
            this._countUp.getCountAnimation(0, TheCrypt.model.gameData.totalSpinWinnings, winRatioConfig.duration - 0.2)
        ]);
        tl.add(() => {
            if (toggleType.length === 0) {
                TheCrypt.reelFrame.onWin();
            }
            toggleType = (toggleType.length > 0 ? "_" : "") + toggleType;
            effect.visible = true;
            effect.state.setAnimation(0, `win${toggleType}`, false);
            TheCryptSoundManager.playSound(`win${winType.charAt(0).toUpperCase() + winType.slice(1)}`);
        }, winRatioConfig.duration - 0.2);
        tl.add([
            () => {
                TheCrypt.keypadPlugin.setWin(TheCrypt.model.gameData.accumulatedRoundWin, true, TheCryptHelper.isWinBelowStake());
            },
            TweenLite.to(this, 1.4, {alpha: 0, delay: 0.6})
        ]);
        tl.add(() => {
            this.removeChild(effect);
            this.removeChild(waysNumber);
            this.removeChild(waysText);
            effect.destroy();
            waysNumber.destroy();
            waysText.destroy();
            this.visible = false;
        });
        return tl;
    }

    private init(): void {
        this._countUp = new BasicBitmapCountUp({
            fontName: TheCryptGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 50,
            tint: 0xffffff
        }, 480, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 360);
        this._countUp.stopAt(0);

        this.visible = false;
        this.addChild(this._countUp);
    }
}